import { validate } from '../../../utils/validate';

/**
 * returns string of 6 stars followed by the last four characters of the value passed
 */
export const getMaskedValue = (value) => `******${value.slice(-4)}`;

/**
 * validates payment source form inputs via utils/validate helper
 */
export const validateSourceFormInputs = ({ dispatchSetInputError, formValues }) =>
  Object.keys(formValues).reduce((isInputError, key) => {
    if (key === 'accountType') {
      return isInputError;
    }

    const validateProps = key === 'accountNumberConfirm' ? {
      comparisonValue: formValues.accountNumberConfirm,
      name: 'Account numbers',
      type: 'concurrentFields',
      value: formValues.accountNumber,
    } : {
      type: key,
      value: formValues[key],
    };

    const { message } = validate({ ...validateProps, required: true });

    if (message) {
      dispatchSetInputError({ field: key, value: message });
    }

    return message ? true : isInputError;
  }, false);
